export const PAGE_LINKS = {
  home: '/',
  adminLogin: '/admin/login',
  admin: '/admin',
  cancelVip: '/admin/cancel_vip',
  saleSlug: '/admin/sale_slug',
}

export const enum UserActionEnum {
  CLICK = '点击',
  SHOW = '展示',
  SEARCH = '搜索',
}

export const enum UserActionElementEnum {
  PAGE = '页面',
  BUTTON = '按钮',
  MODAL = '弹窗',
  SEARCH = '搜索框',
}

export const enum UserActionModuleEnum {
  PC = '快动画PC端',
  MOBILE = '快动画移动端',
}

export const enum ActivityCodeEnum {
  /**
   * 新人活动
   */
  NEW_USER_ACTIVITY = 'new_user_activity',
}
